<template>
<div id="tests-page" class="bulma">
    <div
        class="columns m-0 small-scrollbar"
        :class="{'is-fullscreeen-test': isFullScreenTest}"
    >
        <div
            v-if="!isFullScreenTest"
            class="column is-half-desktop"
            id="tests-document-container"
        >
            <div id="tests-document-content" class="fixed-with-overflow-y small-scrollbar">
                <div class="page-header">
                    <h1 v-html="document.name"></h1>
                </div>
                <div
                    v-html="document.text"
                    class="page-content"
                ></div>
            </div>
        </div>
        <test-confirmation-modal />
        <test-error-modal/>
        <component
            :is="currentComponent"
            id="tests-container" class="column"
        ></component>
    </div>
</div>
</template>

<script>
import TestList from "./list/TestList";
import {mapActions, mapGetters} from "vuex";

import TestConfirmationModal from "./TestConfirmationModal";
import TestPageHeader from "./TestPageHeader";
import TestErrorModal from "./TestErrorModal";

export default {
    name: "TestsManagementPage",
    components: {TestErrorModal, TestPageHeader, TestConfirmationModal, TestList},
    props: {
        initTrans: Object,
        initRoutes: Object,
        locale: {
            type: String,
            default: 'ru'
        },
        document: Object,
    },
    computed: {
        ...mapGetters('tests', [
            'trans',
            'currentComponent',
            'isFullScreenTest',
        ]),
    },
    mounted() {
        this.setTrans(this.initTrans);
        this.setRoutes(this.initRoutes);
        this.setLocale(this.locale);
        this.setCurrentComponent(TestList);
    },
    methods: {
        ...mapActions('tests', [
            'setTrans',
            'setRoutes',
            'setLocale',
            'hideTestsManagementPage',
            'setCurrentComponent',
        ])
    },
}
</script>

<style lang="scss">
    #tests-page {
        width: 100%;
        height: 100%;

        & > .columns {
            height: 100%;
        }

        #tests-document-container {
            max-height: 100%;
            min-height: 100%;
            padding: 25px;


            .page-header h1 {
                font-weight: revert;
                font-size: revert;
            }

            .page-content * {
                margin: revert;
                padding: revert;
                list-style: revert;
            }
        }

        #tests-container {
            display: flex;
            flex-flow: column;
            min-height: 100%;
            padding: 25px;
            box-shadow: -4px 0px 5px -2px rgba(163,165,186,1);
            max-width: 50%;
            .tests-page-header {
                margin-bottom: 20px;
            }

            .button {
                border-radius: 6px;
            }
        }

        .fixed-with-overflow-y {
            max-height: 100%;
            overflow-y: auto;
        }

        .small-scrollbar {
            &::-webkit-scrollbar {
                background-color: transparent;
                width: 16px;
            }

            /* background of the scrollbar except button or resizer */
            &::-webkit-scrollbar-track {
                background-color: transparent;

                &:hover {
                    background-color: #f4f4f4
                }
            }

            /* scrollbar itself */
            &::-webkit-scrollbar-thumb {
                background-color: #babac0;
                border-radius: 16px;
                border: 5px solid #fff;

                &:hover {
                    background-color: #a0a0a5;
                    border: 4px solid #f4f4f4;
                }
            }

            /* set button(top and bottom of the scrollbar) */
            &::-webkit-scrollbar-button {
                display: none;
            }
        }
        .is-fullscreeen-test {
            #tests-container {
                box-shadow: none;
                max-width: 100%;
            }
        }
    }
</style>
